import 'parsleyjs';
import 'parsleyjs/dist/i18n/fr';

const lang = $('body').attr('data-lang');
window.ParsleyValidator.setLocale(lang);

$('.parsley-validate').parsley();
